import { BasketballMessagesSlice } from '@hefe/store';
import { useSelector } from 'react-redux';
import MessagesAppComponent from '../../components/messages-app/messages-app.component';

export default function UserMessagesPage() {
  const userMessages = useSelector(
    BasketballMessagesSlice.basketballUserMessagesSelector
  );
  const loadingUserMessages = useSelector(
    BasketballMessagesSlice.basketballUserMessagesLoadingSelector
  );

  return (
    <MessagesAppComponent
      mode="user"
      messages={userMessages}
      loading={loadingUserMessages}
      allowCompose={false}
      fetchMoreMessages={BasketballMessagesSlice.fetchBasketballUserMessages}
    />
  );
}
